import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CategoriesPage from '@pages/categories/CategoriesPage';
import CategoryViewPage from '@pages/categories/CategoryViewPage';
import CategoryCreatePage from '@pages/categories/CategoryCreatePage';
import CategoryEditPage from '@pages/categories/CategoryEditPage';

export const CategoriesRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<CategoriesPage />} />
            <Route path="/create" element={<CategoryCreatePage />} />
            <Route path="/:id" element={<CategoryViewPage />} />
            <Route path="/:id/edit" element={<CategoryEditPage />} />
        </Routes>
    );
};

export default CategoriesRoutes;
